// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"bx-z","smallCardRow":"cx-z","largeCardRow":"dx-z","productSearchRow":"ex-z","curatedRow":"fx-z"};